import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    summary(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc','tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fareport/summary${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    summaryexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/fareport/summaryexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `fa_summary_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    summaryprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2', 'view'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fareport/summaryprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    category() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/category`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekondb(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fareport/rekondb${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekondbexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/fareport/rekondbexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `fa_rekon_DB_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rekonkr(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/fareport/rekonkr${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    rekonkrexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/fareport/rekonkrexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `fa_rekon_CR_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }

};